import { Container } from "react-bootstrap";

import "react-big-calendar/lib/sass/styles.scss";
import "./Calendar.scss";

import { Desktop, Mobile, Tablet } from "../../components/Devices";
import CalendarEventFilters from "./CalendarEventFilters";
import CalendarFiltersAside from "./CalenderFiltersAside";
import CalenderFiltersOffcanvas from "./CalenderFiltersOffcanvas";
import EventsCalendar from "./EventsCalendar";
import FilterFacets from "./components/FilterFacets";
import LwcErrorBoundary from "../../components/LwcErrorBoundary";
import RegistrationAccordion from "../../components/RegistrationAccordion/RegistrationAccordion";
import classNames from "classnames";
import { useClassFilters } from "./components/ClassFilterProvider";
import { useEffect } from "react";


const CalendarLayout = () => {

	const { showFilters } = useClassFilters();

	useEffect(() => {
		const observer = new IntersectionObserver(
			([evt]) => evt.target.toggleAttribute("stuck", evt.intersectionRatio < 1),
			{ threshold: [1] }
		);

		observer.observe(document.querySelector(".position-sticky"));
	}, []);

	return (
		<>
			<CalendarEventFilters />

			<Container as="main" className={classNames("p-0 d-flex", { "show-filters": showFilters })} fluid id="main">
				<section className="bg-neutral10 py-4 container-xxl px-3 px-md-4">
					<LwcErrorBoundary>
						<EventsCalendar />
					</LwcErrorBoundary>
				</section>

				<Desktop>
					<CalendarFiltersAside>
						<FilterFacets />
					</CalendarFiltersAside>
				</Desktop>

				<Tablet>
					<CalenderFiltersOffcanvas>
						<FilterFacets />
					</CalenderFiltersOffcanvas>
				</Tablet>

				<Mobile>
					<CalenderFiltersOffcanvas>
						<FilterFacets />
					</CalenderFiltersOffcanvas>
				</Mobile>
			</Container>

			<RegistrationAccordion />
		</>
	);
};

export default CalendarLayout;
